module.exports = __webpack_public_path__ + "img/descubre.67705d1c.png";